/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PressKitDocuments } from './PressKitDocuments';
import {
    PressKitDocumentsFromJSON,
    PressKitDocumentsFromJSONTyped,
    PressKitDocumentsToJSON,
} from './PressKitDocuments';
import type { PressKitGuidelineFile } from './PressKitGuidelineFile';
import {
    PressKitGuidelineFileFromJSON,
    PressKitGuidelineFileFromJSONTyped,
    PressKitGuidelineFileToJSON,
} from './PressKitGuidelineFile';
import type { PressKitGuidelineText } from './PressKitGuidelineText';
import {
    PressKitGuidelineTextFromJSON,
    PressKitGuidelineTextFromJSONTyped,
    PressKitGuidelineTextToJSON,
} from './PressKitGuidelineText';
import type { PressKitImage } from './PressKitImage';
import {
    PressKitImageFromJSON,
    PressKitImageFromJSONTyped,
    PressKitImageToJSON,
} from './PressKitImage';
import type { PressKitLogo } from './PressKitLogo';
import {
    PressKitLogoFromJSON,
    PressKitLogoFromJSONTyped,
    PressKitLogoToJSON,
} from './PressKitLogo';
import type { PressKitProfiles } from './PressKitProfiles';
import {
    PressKitProfilesFromJSON,
    PressKitProfilesFromJSONTyped,
    PressKitProfilesToJSON,
} from './PressKitProfiles';
import type { PressKitStatus } from './PressKitStatus';
import {
    PressKitStatusFromJSON,
    PressKitStatusFromJSONTyped,
    PressKitStatusToJSON,
} from './PressKitStatus';
import type { PressKitTag } from './PressKitTag';
import {
    PressKitTagFromJSON,
    PressKitTagFromJSONTyped,
    PressKitTagToJSON,
} from './PressKitTag';

/**
 * プレスキット全体に関する情報
 * @export
 * @interface PressKitOverallData
 */
export interface PressKitOverallData {
    /**
     * 
     * @type {PressKitStatus}
     * @memberof PressKitOverallData
     */
    status: PressKitStatus;
    /**
     * 
     * @type {Array<PressKitLogo>}
     * @memberof PressKitOverallData
     */
    logos: Array<PressKitLogo>;
    /**
     * 
     * @type {Array<PressKitImage>}
     * @memberof PressKitOverallData
     */
    images: Array<PressKitImage>;
    /**
     * 
     * @type {PressKitGuidelineText}
     * @memberof PressKitOverallData
     */
    guidelineText: PressKitGuidelineText;
    /**
     * ガイドラインのPDF一覧
     * @type {Array<PressKitGuidelineFile>}
     * @memberof PressKitOverallData
     */
    guidelineFiles: Array<PressKitGuidelineFile>;
    /**
     * 資料一覧
     * @type {Array<PressKitDocuments>}
     * @memberof PressKitOverallData
     */
    documents: Array<PressKitDocuments>;
    /**
     * プロフィール一覧
     * @type {Array<PressKitProfiles>}
     * @memberof PressKitOverallData
     */
    profiles: Array<PressKitProfiles>;
    /**
     * タグ一覧
     * @type {Array<PressKitTag>}
     * @memberof PressKitOverallData
     */
    tags?: Array<PressKitTag>;
}

/**
 * Check if a given object implements the PressKitOverallData interface.
 */
export function instanceOfPressKitOverallData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "logos" in value;
    isInstance = isInstance && "images" in value;
    isInstance = isInstance && "guidelineText" in value;
    isInstance = isInstance && "guidelineFiles" in value;
    isInstance = isInstance && "documents" in value;
    isInstance = isInstance && "profiles" in value;

    return isInstance;
}

export function PressKitOverallDataFromJSON(json: any): PressKitOverallData {
    return PressKitOverallDataFromJSONTyped(json, false);
}

export function PressKitOverallDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressKitOverallData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': PressKitStatusFromJSON(json['status']),
        'logos': ((json['logos'] as Array<any>).map(PressKitLogoFromJSON)),
        'images': ((json['images'] as Array<any>).map(PressKitImageFromJSON)),
        'guidelineText': PressKitGuidelineTextFromJSON(json['guideline_text']),
        'guidelineFiles': ((json['guideline_files'] as Array<any>).map(PressKitGuidelineFileFromJSON)),
        'documents': ((json['documents'] as Array<any>).map(PressKitDocumentsFromJSON)),
        'profiles': ((json['profiles'] as Array<any>).map(PressKitProfilesFromJSON)),
        'tags': !exists(json, 'tags') ? undefined : ((json['tags'] as Array<any>).map(PressKitTagFromJSON)),
    };
}

export function PressKitOverallDataToJSON(value?: PressKitOverallData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': PressKitStatusToJSON(value.status),
        'logos': ((value.logos as Array<any>).map(PressKitLogoToJSON)),
        'images': ((value.images as Array<any>).map(PressKitImageToJSON)),
        'guideline_text': PressKitGuidelineTextToJSON(value.guidelineText),
        'guideline_files': ((value.guidelineFiles as Array<any>).map(PressKitGuidelineFileToJSON)),
        'documents': ((value.documents as Array<any>).map(PressKitDocumentsToJSON)),
        'profiles': ((value.profiles as Array<any>).map(PressKitProfilesToJSON)),
        'tags': value.tags === undefined ? undefined : ((value.tags as Array<any>).map(PressKitTagToJSON)),
    };
}

